import {BaseService} from './base.service'
import {Uris} from '../common/constants'

export interface IAgencyManagementService {
  getCharacterProblems(param: any): Promise<any>;
  getCharacterProblem(id: any): Promise<any>;
  recordCharPb(param: any): Promise<any>;
  recordAttachmentType(param: any): Promise<any>;
  updateCharPb(id: string, param: any): Promise<any>;
  updateAttachmentType(id: string, param: any): Promise<any>;
  recordAttribute(idc: number, param: any): Promise<any>;
  updateAttribute(idc: string, ida: string, param: any): Promise<any>;
  recordATAttribute(id: string, param: any): Promise<any>;
  updateATAttribute(idt: string, ida: string, param: any): Promise<any>;
  getAttributeTypes(): Promise<any>;
  getAttachmentTypes(param: any): Promise<any>;
  getAttachmentType(id: any): Promise<any>;
  deleteAttachmentType(id: string): Promise<any>;
  deleteCharPb(id: string): Promise<any>;
}

export class AgencyManagementService extends BaseService implements IAgencyManagementService {
  getCharacterProblems (param) {
    return super.get(Uris.AgencyCharacterProblem, param)
  }
  getCharacterProblem (id) {
    return super.get(Uris.CharacterProblemById.replace(':id', id))
  }
  recordCharPb (param) {
    return super.post(Uris.CharacterProblem, param)
  }
  recordAttachmentType (param) {
    return super.post(Uris.AttachmentTypes, param)
  }
  updateCharPb (id, param) {
    return super.patch(Uris.CharacterProblemById.replace(':id', id), param)
  }
  updateAttachmentType (id, param) {
    return super.patch(Uris.AttachmentTypesById.replace(':id', id), param)
  }
  recordAttribute (idc, param) {
    return super.post(Uris.CharPbAttribute.replace(':idc', idc), param)
  }
  updateAttribute (idc, ida, param) {
    return super.patch(Uris.CharPbAttributeById
      .replace(':idc', idc)
      .replace(':ida', ida), param)
  }
  recordATAttribute (id, param) {
    return super.post(Uris.AttachmentTypesAttribute.replace(':id', id), param)
  }
  updateATAttribute (idt, ida, param) {
    return super.patch(Uris.AttachmentTypesAttributeById
      .replace(':idt', idt)
      .replace(':ida', ida), param)
  }
  getAttributeTypes () {
    return super.get(Uris.AttributeTypes)
  }
  getAttachmentTypes (param) {
    return super.get(Uris.AttachmentTypes, param)
  }
  getAttachmentType (id) {
    return super.get(Uris.AttachmentTypesById.replace(':id', id))
  }
  deleteAttachmentType(id:string)
  {
    return super.delete(Uris.AttachmentTypesById.replace(':id', id))
  }
  deleteCharPb (id) {
    return super.delete(Uris.CharacterProblemById.replace(':id', id))
  }
}



// WEBPACK FOOTER //
// ./src/services/am.service.ts